import { AHIcon, AHIconType, Box, OrgIcon, useAHIconSize } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import {
  TodoSubjectIcon_TodoSubject$data,
  TodoSubjectIcon_TodoSubject$key,
} from "./__generated__/TodoSubjectIcon_TodoSubject.graphql";

function resolveSubjectIconType(
  icon: TodoSubjectIcon_TodoSubject$data["icon"]
): AHIconType | null {
  switch (icon) {
    case "org":
      return "org" as const;
    case "issue":
      return "issue" as const;
    case "iot_radio":
      return "iot" as const;
    case "connect":
      return "connect" as const;
    default:
      return null;
  }
}

export function TodoSubjectIcon(props: {
  subject: TodoSubjectIcon_TodoSubject$key;
}) {
  const subject = useFragment(
    graphql`
      fragment TodoSubjectIcon_TodoSubject on TodoSubject {
        icon
        iconUri
      }
    `,
    props.subject
  );
  const iconType = resolveSubjectIconType(subject.icon);

  if (subject.iconUri) {
    return <OrgIcon orgIconUri={subject.iconUri} spaceRight="xsmall" />;
  }
  if (iconType === null) {
    return null;
  }

  return (
    <AHIcon
      type={iconType}
      color="text-washed"
      spaceRight="xsmall"
      size="xsmall"
    />
  );
}
